// extracted by mini-css-extract-plugin
module.exports = {"noBorder":"ConsultModal_noBorder__MXDWM"};